/* Horizontal scrollers for the Aeloo sections.
   One implementation drives every scroller; each entry names its custom
   element, its track, its nav and the gap used between cards so the arrow
   step matches the layout. Arrows only appear while the track overflows. */
(function () {
  var SCROLLERS = [
    { tag: 'aeloo-steps', track: '.aeloo-steps__track', nav: '.aeloo-steps__nav', gap: 15 },
    { tag: 'aeloo-love', track: '.aeloo-love__grid', nav: '.aeloo-love__nav', gap: 15 },
  ];

  function setup(el, conf) {
    if (el.dataset.aelooReady === '1') return;
    var track = el.querySelector(conf.track);
    var nav = el.querySelector(conf.nav);
    if (!track || !nav) return;
    el.dataset.aelooReady = '1';

    var prev = nav.querySelector('[data-dir="prev"]');
    var next = nav.querySelector('[data-dir="next"]');

    function stepSize() {
      var first = track.firstElementChild;
      return first
        ? first.getBoundingClientRect().width + conf.gap
        : track.clientWidth * 0.8;
    }

    function update() {
      var scrollable = track.scrollWidth - track.clientWidth > 2;
      el.classList.toggle('is-scrollable', scrollable);
      nav.setAttribute('aria-hidden', scrollable ? 'false' : 'true');
      if (!scrollable) return;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    nav.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-dir]');
      if (!btn) return;
      track.scrollBy({
        left: btn.dataset.dir === 'next' ? stepSize() : -stepSize(),
        behavior: 'smooth',
      });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
    setTimeout(update, 400);
  }

  function init() {
    SCROLLERS.forEach(function (conf) {
      document.querySelectorAll(conf.tag).forEach(function (el) {
        setup(el, conf);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
